var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 73,
    viewBox: "0 0 59 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 42.284C11.5051 51.3476 19.1308 59.4659 27.6755 66.428C28.7489 67.3026 30.2511 67.3026 31.3245 66.428C39.8692 59.4659 47.4949 51.3476 54 42.284M5 5.08398C11.5051 14.1476 19.1308 22.2659 27.6755 29.228C28.7489 30.1026 30.2511 30.1026 31.3245 29.228C39.8692 22.2659 47.4949 14.1476 54 5.08398",
    stroke: "#3F3F3F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepth);
export default __webpack_public_path__ + "static/media/depth.07f0f8010ca6d6504dec828f1a52032d.svg";
export { ForwardRef as ReactComponent };